/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-06-30 11:14:14
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 13:51:08
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Cascader,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Switch,
  TimePicker,
  Tree,
} from 'antd'
import { DataNode } from 'antd/lib/tree'
import _ from 'lodash'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectEdition } from '../../../../app/applicationSlice'
import { RootDispatch } from '../../../../app/store'
import { EditableList } from '../../../../compnents/list/EditableList'
import { PayMethod } from '../../../../models/payment'
import { Checks, Settinglable, Settings } from '../../../../models/setting'
import { Tenant } from '../../../../models/tenant'
import { setSettings } from '../../../settings/settingsSlice'
import { AutoExpenseModal } from '../../../user/setting/AutoExpenseModal'
import {
  getSettingDetail,
  saveSettingLabel,
  selectAutoCreateFeeVOList,
  selectSettings,
  selectTenant,
  setIsChange,
} from '../../../user/setting/settingSlice'
import styles from '../../functionSettingTabs.module.css'
import { getTenantPreferencesListAsync } from '../../../treatment/editor/recipeEditorSlice'
import { AddOrEditDecoctingPersionalSettingModal } from '../../../treatment/editor/modals/AddOrEditDecoctingPersionalSettingModal'
import { DecoctingPersionalSettingModal } from '../../../treatment/editor/modals/DecoctingPersionalSettingModal'
import { getSaveSomeFunctions } from '../../../registration/register/registerSlice'
import { RecipeNormalFrequencyCategories, RecipeNormalFrequencyName, RecipeNormalUsemethodCategories, RecipeNormalUsemethodName, RecipeNormalDoseCategories, RecipeNormalDoseTypeName } from '../../../../models/decoctingSettingModal'

export const OutpatientSetting = (props: {
  selectedTab: any
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const settings = useSelector(selectSettings)

  const tenant = useSelector(selectTenant)

  const autoCreateFeeVOList = useSelector(selectAutoCreateFeeVOList)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [buttonLoading, setButtonLoading] = useState(false)

  const [autoFeeItem, setAutoFeeItem] = useState<any>()

  const [title, setTitle] = useState('create')

  const [selectIndex, setSelectIndex] = useState<any>()

  const [isOpenReplaceMake, setIsOpenReplaceMake] = useState(false) //是否开通代煎

  const [
    isAddOrEditDecoctingPersionalSettingModalVisible,
    setIsAddOrEditDecoctingPersionalSettingModalVisible,
  ] = useState<any>() //代煎偏好设置

  const [
    isDecoctingPersionalSettingModalVisible,
    setIsDecoctingPersionalSettingModalVisible,
  ] = useState<any>() //代煎偏好设置


  const [selectId, setSelectId] = useState<any>()

  const [selectSupplierId, setSelectSupplierId] = useState<any>()

  const [selectPotionType, setSelectPotionType] = useState<any>()

  const [recipeFormulationSetup, setRecipeFormulationSetup] = useState(false)
  const [batchPriceType, setBatchPriceType] = useState('0') // 混合批次开出时的单价采用方式：0=平均值, 1=原批次价格
  const [kcbzsValue, setKcbzsValue] = useState('0') // 库存不足时当前选中的值，用于控制UI展示

  const [recipeFormulation, setRecipeFormulation] = useState<{
    recipeNormalFrequency?: string
    recipeNormalUsemethod?: string
    recipeNormalDose?: string
  }>({})

  const [page, setPage] = useState({
    items: autoCreateFeeVOList?.map((v?: any, index?: any) => {
      return { ...v, indexId: index }
    }),
    total: 0,
    size: 100,
    current: 1,
  })

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  useEffect(() => {
    if (props?.selectedTab == '3') {
      if (tenant) {
        form.setFieldsValue({
          ...tenant,
          registeredFund: null,
        })
      }
      if (settings) {
        const defaultMethod =
          (parseInt(settings[Checks.Mrzffs]) as PayMethod) || PayMethod.Cash
        dispatch(
          setSettings({
            [Settings.Treatment.DoNotWarnDoctorMismatch]:
              settings[Checks.Gbkdysstx] || false,
            [Settings.Treatment.Settlement]: settings[Checks.Zjjs] || false,
            [Settings.Recipe.ChangePrice]: !(settings[Checks.Gbxgjg] || false),
            [Settings.Payment.DefautMethod]: defaultMethod,
            [Settings.Recipe.AutoChangePrice]: settings[Checks.ZDJSTS] || false,
            [Settings.Recipe.AutoChangePriceAfter]:
              settings[Checks.ZDJSTSBCH] || false,
          })
        )
        form.setFieldsValue({
          ...settings,
          [Checks.Gbkdysstx]: settings[Checks.Gbkdysstx] ? false : true,
          [Checks.FZCFJG]: settings[Checks.FZCFJG] || ['1', '2', '3'],
          [Checks.FZCTJG]: settings[Checks.FZCTJG] || ['1', '2', '3'],
        })
        // 库存不足时回显
        const kcbzs = settings[Checks.KCBZS]
        if (kcbzs) {
          if (kcbzs === '2') {
            setKcbzsValue('2')
            form.setFieldsValue({ [Checks.KCBZS]: '2' })
          } else {
            setKcbzsValue('0')
            form.setFieldsValue({ [Checks.KCBZS]: '0' })
            setBatchPriceType(kcbzs)
          }
        } else {
          // 默认：混合批次开出 + 平均值
          form.setFieldsValue({ [Checks.KCBZS]: '0' })
        }
        console.log(settings, "settings")

        const saved = settings?.[Checks.CSCFJXSZNR]
        if (saved) {
          try {
            setRecipeFormulation(JSON.parse(saved))
          } catch {
            console.error('解析失败', saved)
          }
        } else {
          setRecipeFormulation({
            recipeNormalFrequency: '每日一帖',
            recipeNormalUsemethod: '每帖一次',
            recipeNormalDose: '每次100ml',
          })
        }
      }
    }
  }, [tenant, settings, props?.selectedTab])

  useEffect(() => {
    if (props?.selectedTab == '3') {
      dispatch(getSettingDetail())
    }
  }, [props?.selectedTab])

  const isCheck = (checkState?: any) => {
    dispatch(getTenantPreferencesListAsync())
      .then(unwrapResult)
      .then((v) => {
        const defaultSelectedData = v?.filter((item: any) => {
          return item?.defaultSelected == 1
        })
        if (v?.length) {
          setIsOpenReplaceMake(true)
        } else {
          setIsOpenReplaceMake(false)
        }
        if (checkState) {
          if (!defaultSelectedData?.length) {
            Modal.confirm({
              title: '提示',
              content: (
                <p>
                  您还没有设置默认代煎偏好
                  <span
                    style={{
                      padding: '0 10px',
                      cursor: 'pointer',
                      textDecoration: 'none',
                      color: '#027AFF',
                    }}
                    onClick={() => {
                      Modal.destroyAll()
                      setIsAddOrEditDecoctingPersionalSettingModalVisible(true)
                    }}
                  >
                    去设置
                  </span>
                </p>
              ),
              okButtonProps: { style: { display: 'none' } }, // 隐藏确定按钮
              onCancel: () => {
                form.setFieldsValue({
                  "131": false,
                })
              }
            })
          }
        }
      })
  }
  return (
    <>
      <Col className={styles.settingOutPatient}>
        <Form
          form={form}
          onFinish={(values) => {
            // 检查复制处方价格设置是否选择
            const fzcfjgValue = values[Checks.FZCFJG]
            if (!fzcfjgValue || fzcfjgValue.length === 0) {
              notification.warning({ message: '请选择复制处方价格设置', duration: 3 })
              return
            }

            // 检查添加套餐价格设置是否选择
            const fzctjgValue = values[Checks.FZCTJG]
            if (!fzctjgValue || fzctjgValue.length === 0) {
              notification.warning({ message: '请选择添加套餐价格设置', duration: 3 })
              return
            }

            const pattern = /^[0-9]*$/

            const t = _.chain(values)
              .omitBy((_, k) => pattern.test(k))
              .value() as Tenant

            const f = _.chain(values)
              .pickBy((_, k) => pattern.test(k))
              .mapValues(
                (v, k) =>
                ({
                  type: k,
                  value: k == Checks.Gbkdysstx.toString() ? ((v ? false : true)?.toString()) : v?.toString(),
                } as Settinglable)
              )
              .values()
              .value()
            console.log(f, "fffffff")
            setButtonLoading(true)
            dispatch(
              saveSettingLabel({
                tenant: {
                  ...tenant,
                  ...t,
                },
                functionList: f,
                autoCreateFees: page.items?.map((x: any) => {
                  return {
                    materialsCatalogIds: x.materialsCatalogIds,
                    treatmentServiceIds: x.treatmentServiceIds,
                    conditionType: x.conditionType,
                    countType: x?.countType,
                    conditionMaterialsCatalogIds:
                      x.conditionMaterialsCatalogIds,
                    conditionTreatmentServiceIds:
                      x.conditionTreatmentServiceIds,
                    conditionUsemethod: x.conditionUsemethod,
                    projectCount: x.projectCount,
                  }
                }),
              })
            )
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: '保存成功,部分配置需要重新登陆后生效',
                  duration: 3,
                })
                dispatch(getSettingDetail())
              })
              .catch(() => {
                notification.error({ message: '机构设置保存失败', duration: 3 })
                dispatch(getSettingDetail())
              })
              .finally(() => {
                dispatch(setIsChange(false))
                setButtonLoading(false)
              })
          }}
          onValuesChange={(values, all) => {
            dispatch(setIsChange(true))
          }}
        >
          <div style={{ overflow: 'auto', height: 'calc(100% - 50px)' }}>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
                marginBottom: '16px',
              }}
            >
              病历设置
            </Row>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item label='患者复诊标记' name={Checks.HZFZBJ}>
                <Radio.Group
                  onChange={(e) => {
                    return
                  }}
                >
                  <Radio value={'1'}>默认初诊</Radio>
                  <Radio value={'2'}>
                    {hisVersion === 1
                      ? '有挂号记录的默认复诊'
                      : '老客户默认复诊'}
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='医生开关提醒'
                name={Checks.Gbkdysstx}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                ></Switch>
              </Form.Item>
              <span className={styles.nameTips}>
                开启后，接诊其他医生的患者时会提示非本医生的患者
              </span>
            </Col>
            {/*<Col className={styles.rowHeight} span={24}>*/}
            {/*  <Form.Item*/}
            {/*      label='处方药品种类限制'*/}
            {/*      name={Checks.CFYPZLXZ}*/}
            {/*      valuePropName='checked'*/}
            {/*  >*/}
            {/*    <Switch*/}
            {/*        checkedChildren='开启'*/}
            {/*        unCheckedChildren='关闭'*/}
            {/*    ></Switch>*/}
            {/*  </Form.Item>*/}
            {/*  <span className={styles.nameTips}>*/}
            {/*    开启后，一张处方最多可开具5种药品*/}
            {/*  </span>*/}
            {/*</Col>*/}
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
                marginBottom: '16px',
              }}
            >
              开方设置
            </Row>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item label='药品搜索方式：' name={Checks.YPSSFS}>
                <Radio.Group
                  onChange={(e) => {
                    return
                  }}
                >
                  <Radio value={'1'}>药品名称或追溯码搜索</Radio>
                  <Radio value={'0'}>药品名称或条形码搜索</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='皮试管理'
                name={Checks.Psgl}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                ></Switch>
              </Form.Item>
              <span className={styles.nameTips}>
                开启后，开处方时设置了皮试的药品需要先进行皮试，皮试结果登记后才能进行结算
              </span>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='诊间结算'
                name={Checks.Zjjs}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                ></Switch>
              </Form.Item>
              <span className={styles.nameTips}>
                开启后，在接诊时可以直接进行结算
              </span>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='零库存开药'
                name={Checks.Lkcky}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                  onChange={(v: any) => {
                    dispatch(
                      setSettings({
                        [Settings.Recipe.TcmIgnoreStorage]: v,
                        [Settings.Recipe.IgnoreStorage]: v,
                        [Settings.Recipe.TcmUseSpecifiedBatch]: !v,
                        [Settings.Recipe.UseSpecifiedBatch]: !v,
                      })
                    )
                  }}
                ></Switch>
              </Form.Item>
              <span className={styles.nameTips}>
                开启后，开方搜索范围为商品目录列表，并且不需要发药
              </span>
            </Col>
            {hisVersion != 1 ? <>
              <Col className={styles.herbalCopySetting} span={24}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Form.Item label='中药方初始处方剂型' name={Checks.CSCFJXSZ} style={{ marginBottom: 0 }}>
                    <Radio.Group
                      onChange={(e) => {
                        return
                      }}
                      defaultValue={'1'}
                    >
                      <Radio value={'1'}>沿用上次机构开方的处方剂型</Radio>
                      <Radio value={'0'}>固定处方剂型</Radio>
                    </Radio.Group>
                  </Form.Item>
                  <a onClick={() => {
                    setRecipeFormulationSetup(true)
                  }}>去设置</a>
                </div>
              </Col>
            </> : <></>}
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='中药方默认代煎'
                name={Checks.ZYFMRDJ}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                  onChange={(v: any) => {
                    if (v) {
                      isCheck(true)
                    }
                  }}
                ></Switch>
              </Form.Item>
              <span className={styles.nameTips}>
                开启后，中药方默认会打开代煎
              </span>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='代煎偏好设置'
              >
                <Button type='primary' onClick={() => {
                  isCheck()
                  setIsAddOrEditDecoctingPersionalSettingModalVisible(true)
                }}>代煎偏好设置</Button>
              </Form.Item>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Form.Item
                label='开方自动生成费用'
                name={Checks.KFZDSCFY}
                valuePropName='checked'
              >
                <Switch
                  checkedChildren='开启'
                  unCheckedChildren='关闭'
                ></Switch>
              </Form.Item>
            </Col>
            <Col className={styles.rowHeight} span={24}>
              <Button
                style={{ marginLeft: '150px' }}
                type='primary'
                onClick={() => {
                  setIsModalVisible(true)
                  setAutoFeeItem({})
                  setTitle('create')
                }}
              >
                添加
              </Button>
            </Col>
            <Col
              className={styles.rowHeight}
              span={23}
              style={{ marginLeft: '150px', width: '80%' }}
            >
              <EditableList
                page={page}
                bordered
                pagination={false}
                columns={[
                  {
                    title: '序号',
                    key: 'order',
                    align: 'center',
                    width: '2rem',
                    render: (_1, _2, index) => `${index + 1}`,
                  },
                  {
                    title: '自动生成费用',
                    dataIndex: 'projectDataName',
                    width: '4rem',
                    align: 'center',
                  },
                  {
                    title: '触发条件类型',
                    dataIndex: 'conditionType',
                    width: '4rem',
                    align: 'center',
                    render: function UserSettings(_, u: any): ReactElement {
                      return (
                        <Space>
                          {u.conditionType === 1 ? '药品/诊疗项目' : '用法'}
                        </Space>
                      )
                    },
                  },
                  {
                    title: '内容',
                    dataIndex: 'conditionDataName',
                    width: '8rem',
                    align: 'center',
                    render: function UserSettings(_, u: any): ReactElement {
                      return (
                        <Space>
                          {u.conditionType === 1
                            ? u.conditionDataName
                            : u.conditionUsemethod}
                        </Space>
                      )
                    },
                  },
                  {
                    title: '操作',
                    key: 'actions',
                    width: '4rem',
                    align: 'center',
                    render: function UserSettings(
                      _,
                      u: any,
                      index
                    ): ReactElement {
                      return (
                        <Space>
                          <a
                            onClick={() => {
                              setIsModalVisible(true)
                              setSelectIndex(u?.indexId)
                              setAutoFeeItem({
                                ...u,
                                oldConditionType: u?.conditionType,
                                oldProjectDataName: u?.projectDataName,
                                oldProjectData: u?.projectData,

                                oldConditionData:
                                  u?.conditionType == 1 ? u?.conditionData : [],
                                oldConditionDataName:
                                  u?.conditionType == 1
                                    ? u?.conditionDataName
                                    : '',

                                oldConditionUsemethod: u?.conditionUsemethod,
                              })

                              setTitle('edit')
                            }}
                          >
                            编辑
                          </a>
                          <a
                            onClick={() => {
                              const list = [...page.items]
                              list.splice(index, 1)
                              setPage({
                                ...page,
                                items: list,
                              })
                            }}
                          >
                            删除
                          </a>
                        </Space>
                      )
                    },
                  },
                ]}
              />
            </Col>
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
                marginBottom: '16px',
              }}
            >
              复制处方/添加套餐设置
            </Row>
            <Row style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <Col className={styles.titleLineHeight}>库存不足时 :</Col>
              <Col style={{ flex: 1 }}>
                <Radio
                  checked={kcbzsValue !== '2'}
                  onChange={() => {
                    setKcbzsValue('0')
                    form.setFieldsValue({ [Checks.KCBZS]: batchPriceType })
                  }}
                >
                  混合批次开出
                </Radio>
              </Col>
            </Row>
            <Row style={{ display: 'flex', marginBottom: '8px' }}>
              <Col className={styles.titleLineHeight}></Col>
              <Col className={styles.rowHeight} style={{ flex: 1, marginBottom: 0 }}>
                使用库存价格时，单价采用
                <Select
                  value={batchPriceType}
                  onChange={(v) => {
                    setBatchPriceType(v)
                    setKcbzsValue('0')
                    form.setFieldsValue({ [Checks.KCBZS]: v })
                  }}
                  style={{ width: '120px', margin: '0 8px' }}
                  options={[
                    { label: '平均值', value: '0' },
                    { label: '原批次价格', value: '1' },
                  ]}
                />
                ，使用处方价格和使用目录价格时不受批次影响
              </Col>
            </Row>
            <Row style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
              <Col className={styles.titleLineHeight}></Col>
              <Col style={{ flex: 1 }}>
                <Radio
                  checked={kcbzsValue === '2'}
                  onChange={() => {
                    setKcbzsValue('2')
                    form.setFieldsValue({ [Checks.KCBZS]: '2' })
                  }}
                >
                  下一批次开出
                </Radio>
                <span style={{ color: '#999' }}>自动取下一个足够本次数量的批次</span>
              </Col>
            </Row>
            <Row style={{ display: 'flex', marginBottom: '20px' }}>
              <Col className={styles.titleLineHeight}></Col>
              <Col className={styles.rowHeight} style={{ flex: 1, marginBottom: 0 }}>
                使用库存价格时，单价采用下一批次的价格，使用处方价格和使用目录价格时不受批次影响
              </Col>
            </Row>
            <Form.Item name={Checks.KCBZS} hidden>
              <Input />
            </Form.Item>
            <Row style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
              <Col className={styles.titleLineHeight}>复制处方价格设置 :</Col>
              <Col style={{ flex: 1, }}>
                选择支持的价格，如选择多个则开方时再根据情况选择，如选择一个则开方时无需再次选择
              </Col>
            </Row>
            <Row style={{ display: 'flex', marginBottom: '20px' }}>
              <Col className={styles.titleLineHeight}></Col>
              <Col className={styles.rowHeights} style={{ flex: 1 }}>
                <Form.Item name={Checks.FZCFJG}>
                  <Checkbox.Group>
                    <Checkbox value={'1'}>使用目录价格</Checkbox>
                    <Checkbox value={'2'}>使用处方价格</Checkbox>
                    <Checkbox value={'3'}>使用库存价格<span style={{ color: '#606266' }}>（选择库存价格时诊疗使用目录价格）</span></Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
              <Col className={styles.titleLineHeight}>添加套餐价格设置 :</Col>
              <Col style={{ flex: 1, }}>
                选择支持的价格，如选择多个则开方时再根据情况选择，如选择一个则开方时无需再次选择
              </Col>
            </Row>
            <Row style={{ display: 'flex', marginBottom: '20px' }}>
              <Col className={styles.titleLineHeight}></Col>
              <Col className={styles.rowHeights} style={{ flex: 1 }}>
                <Form.Item name={Checks.FZCTJG}>
                  <Checkbox.Group>
                    <Checkbox value={'1'}>使用目录价格</Checkbox>
                    <Checkbox value={'2'}>使用套餐价格</Checkbox>
                    <Checkbox value={'3'}>使用库存价格<span style={{ color: '#606266' }}>（选择库存价格时诊疗使用目录价格）</span></Checkbox>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>
            {hisVersion !== 1 ?
              <>
                <Col className={styles.herbalCopySetting} span={24}>
                  <Row className={styles.herbalCopyLabelRow}>
                    <Col className={styles.titleLineHeight}>中药方复制设置:</Col>
                    <Col className={styles.herbalCopyLabelText}>
                      中药方复制时，处方剂型默认值设置，请选项以下一种方式
                    </Col>
                  </Row>
                  <Form.Item
                    className={styles.herbalCopyRadioItem}
                    label=' '
                    colon={false}
                    name={Checks.ZYFCOPY}
                    initialValue={'0'}
                  >
                    <Radio.Group className={styles.squareRadioGroup}>
                      <Radio value={'0'}>沿用复制的历史处方的处方剂型</Radio>
                      <Radio value={'1'}>不复制历史处方的处方剂型</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </> :
              <></>}
            <Row
              style={{
                fontSize: 16,
                fontWeight: 'bold',
                borderBottom: '1px dashed #BBBBBB',
                paddingBottom: '10px',
                width: '90%',
                marginBottom: '16px',
              }}
            >
              开药量自动计算设置
            </Row>
            <Row style={{ display: 'flex' }}>
              <Col className={styles.titleLineHeight}>开方自动计算 :</Col>
              <Col className={styles.rowHeight} style={{ flex: 1 }}>
                <Form.Item name={Checks.ZDJSTS} valuePropName='checked'>
                  <Checkbox>自动计算天数(保存前)</Checkbox>
                </Form.Item>
                <Form.Item name={Checks.ZDJSTSBCH} valuePropName='checked'>
                  <Checkbox>自动计算天数(保存后)</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </div>
          <Row style={{ paddingTop: '10px' }}>
            <Col span={12}>
              <Button
                htmlType='button'
                onClick={() => {
                  dispatch(getSettingDetail())
                }}
                style={{
                  float: 'right',
                  marginRight: '10px',
                }}
              >
                取消
              </Button>
            </Col>
            <Col span={12}>
              <Button
                loading={buttonLoading}
                type='primary'
                htmlType='submit'
                style={{
                  float: 'left',
                }}
              >
                保存
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
      <AutoExpenseModal
        visible={isModalVisible}
        maskClosable={false}
        onCancel={() => {
          setIsModalVisible(false)
          // dispatch(getSettingDetail())
        }}
        title={title}
        editDetailMessage={autoFeeItem}
        onSuccess={(m: any) => {
          if (title == 'create') {
            setPage({
              ...page,
              items: page?.items?.length
                ? [...page?.items, m]?.map((v: any, index: any) => {
                  return { ...v, indexId: index }
                })
                : [m]?.map((v: any, index: any) => {
                  return { ...v, indexId: index }
                }),
            })
          } else {
            const data = page?.items?.map((val: any, index?: any) => {
              return {
                ...val,
                projectCount:
                  index == selectIndex ? m?.projectCount : val?.projectCount,
                countType: index == selectIndex ? m?.countType : val?.countType,
                indexId: index,
                treatmentServiceIds:
                  index == selectIndex
                    ? m?.treatmentServiceIds
                    : val?.treatmentServiceIds,
                materialsCatalogIds:
                  index == selectIndex
                    ? m?.materialsCatalogIds
                    : val?.materialsCatalogIds,
                conditionTreatmentServiceIds:
                  index == selectIndex
                    ? m?.conditionTreatmentServiceIds
                    : val?.conditionTreatmentServiceIds,
                conditionMaterialsCatalogIds:
                  index == selectIndex
                    ? m?.conditionMaterialsCatalogIds
                    : val?.conditionMaterialsCatalogIds,
                projectDataName:
                  index == selectIndex
                    ? val?.projectDataName == m?.oldProjectDataName
                      ? m?.projectDataName
                      : val?.projectDataName
                    : val?.projectDataName,
                projectData:
                  index == selectIndex
                    ? val?.projectData?.length == m?.oldProjectData?.length
                      ? m?.projectData
                      : val?.projectData
                    : val?.projectData,
                conditionData:
                  index == selectIndex
                    ? val?.conditionData?.length == m?.oldConditionData?.length
                      ? m?.conditionData
                      : val?.conditionData
                    : val?.conditionData,
                conditionType:
                  index == selectIndex
                    ? val?.conditionType == m?.oldConditionType
                      ? m?.conditionType
                      : val?.conditionType
                    : val?.conditionType,
                conditionDataName:
                  index == selectIndex
                    ? val?.conditionDataName == m?.oldConditionDataName
                      ? m?.conditionDataName
                      : val?.conditionDataName
                    : val?.conditionDataName,
                conditionUsemethod:
                  index == selectIndex
                    ? val?.conditionUsemethod == m?.oldConditionUsemethod
                      ? m?.conditionUsemethod
                      : val?.conditionUsemethod
                    : val?.conditionUsemethod,
              }
            })
            setPage({
              ...page,
              items: data,
            })
          }

          setIsModalVisible(false)
        }}
      />
      <AddOrEditDecoctingPersionalSettingModal
        visible={isAddOrEditDecoctingPersionalSettingModalVisible}
        onOk={() => {
          setIsAddOrEditDecoctingPersionalSettingModalVisible(false)
        }}
        onCancel={() => {
          setIsAddOrEditDecoctingPersionalSettingModalVisible(false)
        }}
        addPersionalMessage={(potionType, supplierId, id) => {
          setSelectPotionType(potionType)
          setSelectSupplierId(supplierId)
          setSelectId(id)
          setIsDecoctingPersionalSettingModalVisible(true)
          setIsAddOrEditDecoctingPersionalSettingModalVisible(false)
        }}
      ></AddOrEditDecoctingPersionalSettingModal>

      <DecoctingPersionalSettingModal
        selectSupplierId={selectSupplierId}
        selectId={selectId}
        selectPotionType={selectPotionType}
        isOpenReplaceMake={isOpenReplaceMake}
        visible={isDecoctingPersionalSettingModalVisible}
        onOk={() => {
          setIsDecoctingPersionalSettingModalVisible(false)
        }}
        onCancel={() => {
          setIsDecoctingPersionalSettingModalVisible(false)
        }}
      ></DecoctingPersionalSettingModal>
      <Modal
        title="处方用法"
        width={700}
        visible={recipeFormulationSetup}
        bodyStyle={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 120 }}
        onCancel={() => setRecipeFormulationSetup(false)}
        onOk={() => {

          const params: any = [
            {
              type: Checks.CSCFJXSZNR,
              value: JSON.stringify(recipeFormulation),
            },
          ]
          // TODO: 保存处方剂型设置
          dispatch(getSaveSomeFunctions({ functionList: params }))
            .then(unwrapResult)
            .then((res: any) => {
              setRecipeFormulationSetup(false)
            })
        }}
      >
        <Form.Item label="处方剂型" style={{ marginBottom: 0 }}>
          <Select
            placeholder="请选择"
            value={recipeFormulation.recipeNormalFrequency}
            onChange={(val) =>
              setRecipeFormulation({ ...recipeFormulation, recipeNormalFrequency: val })
            }
            style={{ width: 150, marginRight: 10 }}
          >
            {RecipeNormalFrequencyCategories?.map((v) => {
              return (
                <Select.Option value={v} key={v}>
                  {RecipeNormalFrequencyName(v)}
                </Select.Option>
              )
            })}
          </Select>
          <Select
            placeholder="请选择"
            value={recipeFormulation.recipeNormalUsemethod}
            onChange={(val) =>
              setRecipeFormulation({ ...recipeFormulation, recipeNormalUsemethod: val })
            }
            style={{ width: 150, marginRight: 10 }}
          >
            {RecipeNormalUsemethodCategories?.map((v) => {
              return (
                <Select.Option value={v} key={v}>
                  {RecipeNormalUsemethodName(v)}
                </Select.Option>
              )
            })}
          </Select>
          <Select
            placeholder="请选择"
            value={recipeFormulation.recipeNormalDose}
            onChange={(val) =>
              setRecipeFormulation({ ...recipeFormulation, recipeNormalDose: val })
            }
            style={{ width: 150 }}
          >
            {RecipeNormalDoseCategories?.map((v) => {
              return (
                <Select.Option value={v} key={v}>
                  {RecipeNormalDoseTypeName(v)}
                </Select.Option>
              )
            })}
          </Select>
        </Form.Item>
      </Modal>
    </>
  )
}
